/**
 * Shape constants shared by the real feed row (`components/feed/job-row.tsx`)
 * and its loading placeholder (`components/feed/feed-skeleton.tsx`).
 *
 * These two drifted badly: the skeleton reserved ~130px per row against a real
 * ~260-320px, so the comment promising "no visible layout shift" actually
 * guaranteed 1,000-1,500px of it, landing at ~3.1s mobile LCP — under the
 * user's thumb. They live here rather than in either component because
 * `job-row.tsx` is `"use client"` and the skeleton is a server component;
 * importing across that boundary to share a number would drag the whole client
 * module into the server bundle.
 */

/**
 * How many signal chips the mobile row may render. Three is the working-memory
 * ceiling for an at-a-glance scan, and it is what the row's height budget can
 * afford — the row previously rendered up to eleven.
 */
export const MOBILE_CHIP_LIMIT = 3;

/**
 * How many signal chips the desktop row may render, in the `feed-badge-row`
 * v2 arm. Desktop was previously uncapped AND skipped the "exactly one fit
 * chip" rule, so a single card could show the fit pill, the hidden-gem pill,
 * the urgency chip and the skills chip at once. Four rather than the mobile
 * three because the desktop row has the width for pay + fit + scarcity + the
 * apply affordance without wrapping. The eligibility-blocker chip is
 * deliberately NOT counted against this budget: it is a protective warning
 * ("US-only", "on-site"), not a reason to apply, and dropping it to make room
 * for a promotional chip would be the wrong trade.
 */
export const DESKTOP_CHIP_LIMIT = 4;

/**
 * Text lines the skeleton reserves, matching the real row: a title that wraps
 * to at most two lines, one company · location meta line, and a
 * `line-clamp-2` blurb.
 */
export const SKELETON_TITLE_LINES = 2;
export const SKELETON_BLURB_LINES = 2;
